import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-totals-display',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ` <div class="flex flex-col items-center text-white uppercase">
    <div class="flex items-center">
      <div
        class="number text-[90px] leading-[108px] font-normal max-[1100px]:text-[70px] max-[1100px]:leading-[80px]"
      >
        {{ activeOrders() || 0 }}
      </div>
      <div
        class="pt-[7px] pl-[15px] text-[19px] leading-[22px] font-bold max-[1100px]:text-base max-[1100px]:leading-[20px]"
      >
        Total Active
        <span
          class="mt-1 flex text-[40px] leading-[48px] font-normal capitalize max-[1100px]:text-[34px] max-[1100px]:leading-[40px]"
        >
          Orders
        </span>
      </div>
    </div>
    <div
      class="mt-1 text-[22px] leading-[21.6px] font-bold text-white max-[1100px]:text-[19px] max-[1100px]:leading-[21px]"
    >
      Spanning {{ activeLocations() || 0 }} locations
    </div>
  </div>`,
})
export class TotalsDisplayComponent {
  readonly activeLocations = input<number>();

  readonly activeOrders = input<number>();
}
